export default __webpack_public_path__ + "static/media/038-slippery.be07b2d5.png";